export const BASE_FONT_SIZE = 10;
